import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import useBreakpoints from '../../hooks/useBreakpoints'
import BalanceText from '../../components/BalanceText'

const Arrow = (props) => (
  <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16A16 16 0 0 0 16 0zm0 30.72C7.87 30.72 1.28 24.13 1.28 16S7.87 1.28 16 1.28 30.72 7.87 30.72 16c-.01 8.126-6.594 14.71-14.72 14.72zm6.852-12.612a.64.64 0 0 1 0 .904l-6.4 6.4a.64.64 0 0 1-.904 0l-6.4-6.4a.64.64 0 0 1 .904-.904l5.308 5.307V7.04a.64.64 0 0 1 1.28 0v16.375l5.308-5.307a.64.64 0 0 1 .904 0z" />
  </svg>
)

const PartnerHero = (props) => {
  const { MD } = useBreakpoints()
  let heroImage = props.heroImage
  const heroGradient =
    props.heroGradient ||
    'linear-gradient(162deg,rgba(19, 20, 27, 0.4),rgba(19, 20, 27, 0.9))'

  useEffect(() => {
    if (props.heroImageMobile && !MD) {
      // FIXME: dont ignore
      // eslint-disable-next-line react-hooks/exhaustive-deps
      heroImage = props.heroImageMobile
    }
  }, [MD])

  return (
    <div className={`relative text-white`} data-uid="partner-hero">
      <div
        className="relative py-128"
        style={{
          background: `${heroGradient}, url(${heroImage}) left/cover`,
        }}
      >
        <div className="pin flex flex-col items-center justify-center text-center type-24">
          <h1 className="type-huge mb-32 max-w-1280 px-20 lg:mx-24 lg:mx-auto lg:mb-64">
            <div className="mb-12 leading-default type-17-demibold-caps">
              <BalanceText>
                <span>{props.subHeading}</span>
              </BalanceText>
            </div>
            {props.heading}
          </h1>
          {props.ctaButton}
        </div>
        <div className="absolute bottom-0 z-10 w-full pb-24 text-center">
          <a href="#start" className="cursor-pointer">
            <Arrow fill="#fff" />
          </a>
        </div>
      </div>
    </div>
  )
}

PartnerHero.propTypes = {
  ctaButton: PropTypes.node,
  heading: PropTypes.node,
  subHeading: PropTypes.node,
  heroImage: PropTypes.string,
  heroImageMobile: PropTypes.string,
  heroGradient: PropTypes.string,
  partner: PropTypes.string,
  rootUrl: PropTypes.string,
}

export default PartnerHero
